var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('img',{attrs:{"src":require("@/assets/data-screen/card-header.png"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }